module.exports = __webpack_public_path__ + "static/icons-blue-outlines-bf98cef8fa96688ae46df068386b0f86.png";